// `/survey/{co}/{token}` (BIZ-CLIENT-HEALTH): a client contact's NPS or CSAT survey. A public
// route, outside the auth guard like `/respond/`: the token is the key, and the contact has no
// account (session-expiry skips `/survey/`).
import { createRoute } from "@tanstack/react-router";
import { SurveyPage } from "../features/survey/survey-page";
import { rootRoute } from "./__root";

export const surveyRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "survey/$co/$token",
  component: function Survey() {
    const { api } = surveyRoute.useRouteContext();
    const { co, token } = surveyRoute.useParams();
    return <SurveyPage api={api} co={co} token={token} />;
  },
});
